import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly THEME_KEY = 'theme';

  constructor() {
    this.loadInitialTheme();
  }

  // Load theme on app start
  loadInitialTheme(): void {
    const savedTheme = localStorage.getItem(this.THEME_KEY);
    if (savedTheme === 'dark') {
      this.setDarkTheme();
    } else {
      this.setLightTheme();
    }
  }

  toggleTheme(): void {
    const isDark = this.getCurrentTheme() === 'dark';
    if (isDark) {
      this.setLightTheme();
    } else {
      this.setDarkTheme();
    }
  }

  setDarkTheme(): void {
    document.documentElement.classList.add('dark');
    localStorage.setItem(this.THEME_KEY, 'dark');
  }

  setLightTheme(): void {
    document.documentElement.classList.remove('dark');
    localStorage.setItem(this.THEME_KEY, 'light');
  }

  getCurrentTheme(): string {
    return localStorage.getItem(this.THEME_KEY) || 'light';
  }

  isDarkMode(): boolean {
    return this.getCurrentTheme() === 'dark';
  }
}
